
// Agent-facing hospital picker row (#656). Mirrors PharmaciesList.vue, with
// two differences forced by the data: hospitals are keyed by Oracle's
// `provider_id` rather than an NPI, and they carry a type and a CMS star
// rating worth showing next to the address.
//
// Manually-added hospitals have no provider_id at all (the client-facing
// HospitalsStep lets someone type a name), which is why identity falls back to
// the name — matching that step's own isAdded() check.
import _ from 'lodash'

export default {
    props: {
        results: {
            type: Array,
            default: () => []
        },
        value: {
            type: Array,
            default: () => []
        },
        removable: {
            type: Boolean,
            default: false
        },
        showSelectedOnly: {
            type: Boolean,
            default: false
        },
    },
    methods: {
        findHospitalIndex (hospital) {
            return _.findIndex(this.value, h => (
                hospital.provider_id ? h.provider_id === hospital.provider_id : h.name === hospital.name
            ))
        },
        isHospitalInList (hospital) {
            return this.findHospitalIndex(hospital) > -1
        },
        meta (hospital) {
            return [
                hospital.hospital_type,
                hospital.overall_rating ? `${hospital.overall_rating}★` : null,
            ].filter(Boolean).join(' · ')
        },
    }
}
